import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createSlots as _createSlots, Teleport as _Teleport } from "vue"
import _imports_0 from '@/assets/img/Icons/buttons/arrow-diag.svg'
import _imports_1 from '@assets/img/Rolling-loading.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "payment_field" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "information" }
const _hoisted_5 = { class: "payment_field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "IBAN", -1)
const _hoisted_7 = { class: "information" }
const _hoisted_8 = { class: "payment_field" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "information" }
const _hoisted_11 = { class: "payment_field" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "information" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "payment_field" }
const _hoisted_16 = { class: "name" }
const _hoisted_17 = { class: "information" }
const _hoisted_18 = { class: "payment_field" }
const _hoisted_19 = { class: "name" }
const _hoisted_20 = { class: "information" }
const _hoisted_21 = { class: "payment_field" }
const _hoisted_22 = { class: "name" }
const _hoisted_23 = { class: "information" }
const _hoisted_24 = { class: "payment_field" }
const _hoisted_25 = { class: "name" }
const _hoisted_26 = { class: "information" }
const _hoisted_27 = { class: "payment_field" }
const _hoisted_28 = { class: "name" }
const _hoisted_29 = { class: "information" }
const _hoisted_30 = { class: "payment_field" }
const _hoisted_31 = { class: "name" }
const _hoisted_32 = { class: "information" }
const _hoisted_33 = {
  class: "pin-code-form",
  action: "",
  role: "form",
  "data-lng": "ru"
}
const _hoisted_34 = { class: "pin-code-form_btn_box" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "loader"
}, null, -1)
const _hoisted_37 = [
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_message_success = _resolveComponent("ui-message-success")!
  const _component_ui_pin_code = _resolveComponent("ui-pin-code")!
  const _component_ui_message_error = _resolveComponent("ui-message-error")!
  const _component_aba_button = _resolveComponent("aba-button")!
  const _component_modal_fullscreen = _resolveComponent("modal-fullscreen")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_modal_fullscreen, {
      visible: _ctx.visible,
      onClose: _ctx.close,
      type: "2",
      hideFooter: _ctx.IsSuccess,
      hideHeader: _ctx.IsSuccess
    }, _createSlots({
      body: _withCtx(() => [
        (!_ctx.IsSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.translation("Recipient")), 1),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.model.Recipient), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.model.AccountNumber), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.translation("Amount")), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.model.Amount) + " EUR", 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.translation("Commission")), 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.model.Commission) + " EUR", 1)
              ]),
              (!_ctx.isOffline)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.translation("Address")), 1),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.model.BeneficiaryAddress), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.translation("Country")), 1),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.model.BeneficiaryCountryCode), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.translation("City")), 1),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.model.BeneficiaryCity), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.translation("State")), 1),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.model.BeneficiaryState), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.translation("PostalCode")), 1),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.model.BeneficiaryPostalCode), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.translation("PurposePayment")), 1),
                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.model.PurposePayment), 1)
              ])
            ]))
          : (_openBlock(), _createBlock(_component_ui_message_success, {
              key: 1,
              text: _ctx.$localization.getTranslate('PaymentSuccessfullyCompleted') + '!'
            }, null, 8, ["text"]))
      ]),
      _: 2
    }, [
      (!_ctx.IsSuccess)
        ? {
            name: "header",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.translation("ConfirmationPayment")), 1)
            ]),
            key: "0"
          }
        : undefined,
      (!_ctx.IsSuccess)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_ui_pin_code, {
                  onOnInputPin: _ctx.onInputPin,
                  isClearPin: _ctx.visible
                }, null, 8, ["onOnInputPin", "isClearPin"]),
                _createVNode(_component_ui_message_error, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.ErrMessage), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_34, [
                  (!_ctx.IsLoad)
                    ? (_openBlock(), _createBlock(_component_aba_button, {
                        key: 0,
                        class: "active m-2",
                        btnSize: "btnLarge",
                        onClick: _ctx.Transfer
                      }, {
                        default: _withCtx(() => [
                          _hoisted_35,
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.translation("Confirm")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass([{ active: _ctx.IsLoad }, "loader-gif"])
                  }, _hoisted_37, 2)
                ])
              ])
            ]),
            key: "1"
          }
        : undefined
    ]), 1032, ["visible", "onClose", "hideFooter", "hideHeader"])
  ]))
}